import type { NotificationListResponseNotificationsItem } from './notificationListResponseNotificationsItem';
import type { NotificationListResponsePagination } from './notificationListResponsePagination';

/**
 * 알림 목록 응답 데이터
 */
export interface NotificationListResponse {
  /** 알림 목록 */
  notifications?: NotificationListResponseNotificationsItem[];
  /** Spring Data Page 객체 형태의 페이징 정보 */
  pagination?: NotificationListResponsePagination;
  /** 읽지 않은 알림 수 */
  unreadCount?: number;
}
